
import React from "react";
import CorporateFilter from "./CorporateFilter";
import DateFilter from "./DateFilterByMUI";
import SearchFilter from "./SearchFilter";
import ExportFilter from "./ExportFilter";
import { useMediaQuery, useTheme, Box, Grid, Paper } from "@mui/material";

const HeaderFilter = ({
  enableCorporateFilter,
  enableDateFilter,
  enableSearchFilter,
  enableExportFilter,
  // CorporateFilter props
  mainData,
  selectedCorporate,
  setSelectedCorporate,
  corporateData,
  setCorporateData,
  setFilteredData,
  // DateFilter props
  startDateValue,
  endDateValue,
  setStartDateValue,
  setEndDateValue,
  setIsRefereshData,
  // SearchFilter props
  searchValue,
  setSearchValue,
  setSearchFilteredData,
  styling,
  placeholder,
  data,
  // export Filter props
  onclick,
  // loading
  loading,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? 2 : 1,
        alignItems: isMobile ? "stretch" : "flex-start",
      }}
    >
      {/* Filters on the right side */}
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? 2 : "6px",
          width: isMobile ? "100%" : "auto",
          alignItems: isMobile ? "stretch" : "center",
          marginLeft: isMobile ? 0 : "auto",
        }}
      >
        {/* Corporate Filter - First on the right */}
        {enableCorporateFilter && localStorage.getItem("roleId") == "1" && (
          <Box
            sx={{
              width: isMobile ? "100%" : "auto",
              order: isMobile ? 1 : 0,
            }}
          >
            <CorporateFilter
              mainData={mainData}
              selectedCorporate={selectedCorporate}
              setSelectedCorporate={setSelectedCorporate}
              corporateData={corporateData}
              setCorporateData={setCorporateData}
              setFilteredData={setFilteredData}
              loading={loading}
              setIsRefereshData={setIsRefereshData}
              isMobile={isMobile}
            />
          </Box>
        )}

        {/* Search Filter - Second on the right */}
        {enableSearchFilter && (
          <Box
            sx={{
              width: isMobile ? "100%" : "250px",
              order: isMobile ? 2 : 0,
            }}
          >
            <SearchFilter
              data={data}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              setFilteredData={setSearchFilteredData}
              loading={loading}
              placeholder={placeholder}
              isMobile={isMobile}
            />
          </Box>
        )}

        {/* Date Filter - Third on the right */}
        {enableDateFilter && (
          <Box
            sx={{
              width: isMobile ? "100%" : "auto",
              order: isMobile ? 3 : 0,
            }}
          >
            <DateFilter
              startDateValue={startDateValue}
              endDateValue={endDateValue}
              setStartDateValue={setStartDateValue}
              setEndDateValue={setEndDateValue}
              setIsRefereshData={setIsRefereshData}
              loading={loading}
              isMobile={isMobile}
            />
          </Box>
        )}
      </Box>

      {/* Export Filter - Third Row */}
      {enableExportFilter && (
        <Box
          sx={{
            width: isMobile ? "100%" : "auto",
            display: "flex",
            justifyContent: isMobile ? "flex-start" : "flex-end",
            order: isMobile ? 3 : 0,
          }}
        >
          <ExportFilter onclick={onclick} isMobile={isMobile} />
        </Box>
      )}
    </Box>
  );
};

export default HeaderFilter;
